import { Img } from '@chakra-ui/image'
import { Box, Flex, Grid, GridItem, Text } from '@chakra-ui/layout'
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/tabs'
import MaskGroup1 from '../../assets/image/MaskGroup1.webp'
import Frame46 from '../../assets/image/Frame46.webp'
import hindujahos from '../../assets/image/hindujahos.webp'
import { Button, Card, CardHeader, Heading } from '@chakra-ui/react'
import ambulancecard from '../../assets/image/ambulancecard.webp';
import ambulancesecondcard from '../../assets/image/ambulancesecondcard.webp';
import thirdcard from '../../assets/image/thirdcard.webp';
import fourthcard from '../../assets/image/fourthcard.webp';
import helicoptercard from '../../assets/image/helicoptercard.webp';
import ambulanceservicecard from '../../assets/image/ambulanceservicecard.webp';
import { useNavigate } from 'react-router-dom'

const OurServices = ({ headertext, show = true, mt = '3rem' }) => {
    const navigate = useNavigate()
    return (
        <Box
            mx="auto"
            // maxW="90rem"
            maxW={{ base: '100rem', sm: '100rem', md: '45rem', lg: '60rem', xl: '86rem' }}
            transition="0.5 ease-out"
        >
            <Box
                className='main-section'
                mt={mt}
                py={{ base: '0', sm: '0', md: '2rem', lg: '2rem', xl: '2rem' }}
                px={{ base: '0', sm: '0', md: '8rem', lg: '8rem', xl: '8rem' }}
            >
                <Text
                    textAlign="center"
                    color="#FB1923"
                    textTransform="uppercase"
                    fontWeight="bold"
                    fontSize="3xl"
                    letterSpacing="3px"
                >{headertext}</Text>
                <Grid mt={'2rem'} templateColumns={{ base: 'repeat(1, 1fr)', sm: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)' }} mx={{ base: '4', sm: '4', md: '0' }} rowGap={6} columnGap={6}>
                    <GridItem >
                        <Card
                            px={{ base: 4, sm: 4, md: 2, lg: 2, xl: 2 }}
                            py={{ base: 4, sm: 4, md: 0, lg: 0, xl: 0 }}
                            height={'100%'} border='1px solid #DCDCDC' borderRadius='30px' overflow={'hidden'} className='mty' position="relative"
                        >
                            <CardHeader >
                                <Img roundedTop='30px' width='100%' objectFit='cover' loading='lazy' src={ambulancecard} alt='ambulance' m={'auto'} />
                                <Box bg='#FB1923' h='3px' w='80px' m='auto' marginTop='1.5rem' />
                                <Heading
                                    fontWeight={700}
                                    // lineHeight={'20px'}
                                    fontSize={'18px'}
                                    className='main-section'
                                    size='md' textAlign={'center'} mt={5} > BLS-  Basic Ambulance With O2 (oxygen)</Heading>
                                <Text
                                    className='main-section'
                                    fontWeight={400}
                                    // lineHeight={'20px'}
                                    fontSize={'14px'}
                                    mt={2} textAlign={'center'}>Offering rapid response and oxygen support for patients in need of basic medical assistance.</Text>
                            </CardHeader>
                            <Box className='mtn'>
                                <Flex justifyContent='center' width='100%' alignItems='center' height='100%'>
                                    <Button
                                        filter='drop-shadow(0,4,7 rgba(177, 64, 69, 0.37))'
                                        className='main-section'
                                        width={200}
                                        height='60px'
                                        rounded='6px'
                                        color='#FB1923'
                                        fontWeight={700}
                                        fontSize={18}
                                        onClick={() => { navigate('/Services/BasicAmbulance') }}
                                    >Read More</Button>
                                </Flex>
                            </Box>
                            {/* <CardBody textAlign={'center'} mb={4}>
                        </CardBody> */}
                        </Card>
                    </GridItem>
                    <GridItem>
                        <Card overflow='hidden' className='mty' border='1px solid #DCDCDC' borderRadius='30px'
                            px={{ base: 4, sm: 4, md: 2, lg: 2, xl: 2 }}
                            py={{ base: 4, sm: 4, md: 0, lg: 0, xl: 0 }}
                            height={'100%'} position='relative'>
                            <CardHeader>
                                <Img roundedTop='30px' width='100%' objectFit='cover' loading='lazy' src={ambulancesecondcard} alt='ambulance' m={'auto'} />
                                <Box bg='#FB1923' h='3px' w='80px' m='auto' marginTop='1.5rem' />
                                <Heading
                                    fontWeight={700}
                                    // lineHeight={'20px'}
                                    fontSize={'18px'}
                                    className='main-section'
                                    size='md' textAlign={'center'} mt={5}> ALS - Cardiac Ambulance ICU Setup With BHMS Doctor</Heading>
                                <Text
                                    className='main-section'
                                    fontWeight={400}
                                    // lineHeight={'20px'}
                                    fontSize={'14px'}
                                    mt={2} textAlign={'center'} >Providing advanced cardiac care and intensive care support with a trained BHMS doctor onboard.</Text>
                            </CardHeader>
                            <Box className='mtn'>
                                <Flex justifyContent='center' width='100%' alignItems='center' height='100%'>
                                    <Button
                                        filter='drop-shadow(0,4,7 rgba(177, 64, 69, 0.37))'
                                        className='main-section'
                                        width={200}
                                        height='60px'
                                        rounded='6px'
                                        color='#FB1923'
                                        fontWeight={700}
                                        fontSize={18}
                                        onClick={() => { navigate('/Services/AdvanceAmbulance') }}
                                    >Read More</Button>
                                </Flex>
                            </Box>
                            {/* <CardBody textAlign={'center'} mb={4}>
                            </CardBody> */}
                        </Card>
                    </GridItem>
                    <GridItem>
                        <Card overflow={'hidden'} className='mty' border='1px solid #DCDCDC' borderRadius='30px'
                            px={{ base: 4, sm: 4, md: 2, lg: 2, xl: 2 }}
                            py={{ base: 4, sm: 4, md: 0, lg: 0, xl: 0 }}
                            height={'100%'} >
                            <CardHeader>
                                <Img roundedTop='30px' width='100%' objectFit='cover' loading='lazy' src={thirdcard} alt='ambulance' m={'auto'} />
                                <Box bg='#FB1923' h='3px' w='80px' m='auto' marginTop='1.5rem' />
                                <Heading
                                    fontWeight={700}
                                    // lineHeight={'20px'}
                                    fontSize={'18px'}
                                    className='main-section'
                                    size='md' textAlign={'center'} mt={5}> NICU - Newborns Baby ICU</Heading>
                                <Text
                                    className='main-section'
                                    fontWeight={400}
                                    // lineHeight={'20px'}
                                    fontSize={'14px'}
                                    mt={2} textAlign='center'>Ensuring specialized intensive care for newborns with dedicated medical attention from a doctor.</Text>
                            </CardHeader>
                            <Box className='mtn'>
                                <Flex justifyContent='center' width='100%' alignItems='center' height='100%'>
                                    <Button
                                        filter='drop-shadow(0,4,7 rgba(177, 64, 69, 0.37))'
                                        className='main-section'
                                        width={200}
                                        height='60px'
                                        rounded='6px'
                                        color='#FB1923'
                                        fontWeight={700}
                                        fontSize={18}
                                        onClick={() => { navigate('/Services/NewbornsBabyICU') }}
                                    >Read More</Button>
                                </Flex>
                            </Box>
                            {/* <CardBody textAlign={'center'} mb={4} >
                            </CardBody> */}
                        </Card>
                    </GridItem>
                    <GridItem>
                        <Card overflow={'hidden'} className='mty' border='1px solid #DCDCDC' borderRadius='30px'
                            px={{ base: 4, sm: 4, md: 2, lg: 2, xl: 2 }}
                            py={{ base: 4, sm: 4, md: 0, lg: 0, xl: 0 }}
                            height={'100%'} >
                            <CardHeader>
                                <Img roundedTop='30px' width='100%' objectFit='cover' loading='lazy' src={fourthcard} alt='ambulance' m={'auto'} />
                                <Box bg='#FB1923' h='3px' w='80px' m='auto' marginTop='1.5rem' />
                                <Heading
                                    fontWeight={700}
                                    // lineHeight={'20px'}
                                    fontSize={'18px'}
                                    className='main-section'
                                    size='md' textAlign={'center'} mt={5} > Hearse Ambulance Service - Dead Body With Ice box</Heading>
                                <Text
                                    fontWeight={400}
                                    // lineHeight={'20px'}
                                    fontSize={'14px'}
                                    className='main-section'
                                    mt={2} textAlign='center'>Facilitating dignified transportation of deceased individuals with proper preservation methods</Text>
                            </CardHeader>
                            <Box className='mtn'>
                                <Flex justifyContent='center' width='100%' alignItems='center' height='100%'>
                                    <Button
                                        filter='drop-shadow(0,4,7 rgba(177, 64, 69, 0.37))'
                                        className='main-section'
                                        width={200}
                                        height='60px'
                                        rounded='6px'
                                        color='#FB1923'
                                        fontWeight={700}
                                        fontSize={18}
                                        onClick={() => { navigate('/Services/HearseAmbulanceServices') }}
                                    >Read More</Button>
                                </Flex>
                            </Box>
                            {/* <CardBody textAlign={'center'} mb={4}>
                            </CardBody> */}
                        </Card>
                    </GridItem>
                    <GridItem>
                        <Card className='mty' overflow={'hidden'} border='1px solid #DCDCDC' borderRadius='30px'
                            px={{ base: 4, sm: 4, md: 2, lg: 2, xl: 2 }}
                            py={{ base: 4, sm: 4, md: 0, lg: 0, xl: 0 }}
                            height={'100%'} >
                            <CardHeader>
                                <Img roundedTop='30px' width='100%' objectFit='cover' loading='lazy' src={helicoptercard} alt='helicopter' m={'auto'} />
                                <Box bg='#FB1923' h='3px' w='80px' m='auto' marginTop='1.5rem' />
                                <Heading
                                    fontWeight={700}
                                    // lineHeight={'20px'}
                                    fontSize={'18px'}
                                    className='main-section'
                                    size='md' textAlign={'center'} mt={5}> Air Ambulance Service</Heading>
                                <Text
                                    fontWeight={400}
                                    // lineHeight={'20px'}
                                    fontSize={'14px'}
                                    className='main-section'
                                    mt={2} textAlign='center'>Enabling swift and efficient medical transportation via air for critical cases requiring urgent care.</Text>
                            </CardHeader>
                            <Box className='mtn'>
                                <Flex justifyContent='center' width='100%' alignItems='center' height='100%'>
                                    <Button
                                        filter='drop-shadow(0,4,7 rgba(177, 64, 69, 0.37))'
                                        className='main-section'
                                        width={200}
                                        height='60px'
                                        rounded='6px'
                                        color='#FB1923'
                                        fontWeight={700}
                                        fontSize={18}
                                        onClick={() => { navigate('/Services/AirAmbulanceService') }}
                                    >Read More</Button>
                                </Flex>
                            </Box>
                            {/* <CardBody textAlign={'center'} mb={4}>
                            </CardBody> */}
                        </Card>
                    </GridItem>
                    <GridItem>
                        <Card className='mty' overflow={'hidden'} border='1px solid #DCDCDC' borderRadius='30px'
                            px={{ base: 4, sm: 4, md: 2, lg: 2, xl: 2 }}
                            py={{ base: 4, sm: 4, md: 0, lg: 0, xl: 0 }}
                            height={'100%'}>
                            <CardHeader>
                                <Img roundedTop='30px' width='100%' objectFit='cover' loading='lazy' src={ambulanceservicecard} alt='helicopter' m={'auto'} />
                                <Box bg='#FB1923' h='3px' w='80px' m='auto' marginTop='1.5rem' />
                                <Heading
                                    fontWeight={700}
                                    // lineHeight={'20px'}
                                    fontSize={'18px'}
                                    className='main-section'
                                    size='md' textAlign={'center'} mt={5}> Train Ambulance Service</Heading>
                                <Text
                                    className='main-section'
                                    fontWeight={400}
                                    // lineHeight={'20px'}
                                    fontSize={'14px'}
                                    mt={2} textAlign='center'>Providing medical evacuation and transportation via train, ensuring safe transit for patients across distances.</Text>
                            </CardHeader>
                            <Box className='mtn'>
                                <Flex justifyContent='center' width='100%' alignItems='center' height='100%'>
                                    <Button
                                        filter='drop-shadow(0,4,7 rgba(177, 64, 69, 0.37))'
                                        className='main-section'
                                        width={200}
                                        height='60px'
                                        rounded='6px'
                                        color='#FB1923'
                                        fontWeight={700}
                                        fontSize={18}
                                        onClick={() => { navigate('/Services/TrainAmbulanceService') }}
                                    >Read More</Button>
                                </Flex>
                            </Box>
                            {/* <CardBody textAlign={'center'} mb={4}>
                        </CardBody> */}
                        </Card>
                    </GridItem>
                </Grid>
                {
                    show && <Tabs variant='soft-rounded' colorScheme='green' mt='1rem' >
                        <TabList
                            className='Home_tabs_btn'
                            mx="auto"
                            maxW={{ base: '100%', sm: '100%', md: '100%', lg: '80%', xl: '75%' }}
                            justifyContent="space-between"
                            pb="2rem!important"
                            pt={{ base: '2rem!important', sm: '2rem!important', md: '4rem!important', lg: '4rem!important', xl: '4rem!important' }}
                            px={{ base: '1rem!important', sm: '1rem!important', md: '0rem!important', lg: '0rem!important', xl: '0rem!important' }}
                        >
                            <Tab>Intra-City</Tab>
                            <Tab>Inter-City</Tab>
                            <Tab>For Organisations</Tab>
                        </TabList>
                        <TabPanels className='img_fit'>
                            <TabPanel p={0} outline="0!important" outlineOffset="0">
                                <Grid
                                    alignItems="center"
                                    templateColumns={{ base: 'repeat(1, 1fr)', sm: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', lg: 'repeat(2, 1fr)', xl: 'repeat(2, 1fr)' }} gap={0}>
                                    <GridItem w='100%' h="100%" >
                                        <Img loading='lazy' src={MaskGroup1} alt="ambulance" />
                                    </GridItem>
                                    <GridItem height="100%" w='100%' bg='#eeeeee' >
                                        <Flex className='main-section' fontSize={{ base: '14px', sm: '12px', md: '12px', lg: '14px', xl: '14px' }} lineHeight="21px" height="100%" alignItems="center" py="2rem" px="3rem">
                                            Our Intra-City Ambulance Services transport patient/ healthcare supplies within the city. Well-equipped with first-aid tools, life-saving amenities like ICU and ventilator, and proficient first responders, our 24x7 ambulance service caters to every need - from Basic and Advanced to Heart Care, Neo-Natal, Hearse and more, anywhere within the city.
                                        </Flex>
                                    </GridItem>
                                </Grid>
                            </TabPanel>
                            <TabPanel p={0} outline="0!important" outlineOffset="0">
                                <Grid alignItems="center"
                                    templateColumns={{ base: 'repeat(1, 1fr)', sm: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', lg: 'repeat(2, 1fr)', xl: 'repeat(2, 1fr)' }}
                                    gap={0}>
                                    <GridItem w='100%' h="100%" >
                                        <Img loading='lazy' src={Frame46} alt="ambulance" />
                                    </GridItem>
                                    <GridItem height="100%" w='100%' bg='#eeeeee' >
                                        <Flex fontSize={{ base: '14px', sm: '12px', md: '12px', lg: '14px', xl: '14px' }} lineHeight="21px" height="100%" alignItems="center" py="2rem" px="3rem">
                                            Our Inter-City Ambulance Services transport patient/ healthcare supplies from one city to another. Equipped with basic and advanced life support systems like ICUs and ventilators, first-aid medical essentials and experienced paramedical staff, we provide ambulances to suit every requirement - from BLS and ALS to Heart Care, Neo-Natal etc - in our 24x7 Inter-City Ambulance facility.</Flex>
                                    </GridItem>
                                </Grid>
                            </TabPanel>
                            <TabPanel p={0} outline="0!important" outlineOffset="0">
                                <Grid alignItems="center"
                                    templateColumns={{ base: 'repeat(1, 1fr)', sm: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', lg: 'repeat(2, 1fr)', xl: 'repeat(2, 1fr)' }}
                                    gap={0}>
                                    <GridItem w='100%' h="100%" >
                                        <Img loading='lazy' src={hindujahos} alt="ambulance" />
                                    </GridItem>
                                    <GridItem height="100%" w='100%' bg='#eeeeee' >
                                        <Flex fontSize={{ base: '14px', sm: '12px', md: '12px', lg: '14px', xl: '14px' }} lineHeight="21px" height="100%" alignItems="center" py="2rem" px="3rem">
                                            As a 24x7 ambulance service that provides the right care to the right people at the right time, we partner with organizations - corporates/ hospitals/ Government bodies - to deliver emergency healthcare solutions as part of our endeavour to ensure how best we can serve the community at large. We have served corporates like Sony and Reliance, hospitals like Fortis and Hinduja, and Government bodies like Mumbai Police and BMC, among many others.
                                        </Flex>
                                    </GridItem>
                                </Grid>
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                }

            </Box>
        </Box>
    )
}

export default OurServices